import React, { Component } from 'react';
import assets from '../../containers/tree/assets';

import {
  isMobilePhone
} from '../../library/calc';

import {
  nodeWidth,
  nodeHeight,
  picDim,
  editTreeActionOpacity,
  exStockColors,
  claimedColor,
  masterProfileColor,
  puplicProfileColor,
  isRtl,
  matchesColors
} from '../../library/constants';
import './base.css';


export default class Base extends Component {

  multiple = 3;
  strokeWidth = 1;

  margin = 2 * this.multiple;

  halfNodeWidth = nodeWidth/2;
  mobileNodeLeft = (window.innerWidth/2) - this.halfNodeWidth * this.multiple;
  desktopNodeLeft = isRtl ? 140: 132;
  nodeLeft = ( isMobilePhone() ? this.mobileNodeLeft: this.desktopNodeLeft)

  nodeX = this.nodeLeft;
  nodeY = 80;

  nameY = this.nodeY;
  scaleRowLineHeight = 6 * this.multiple;

  buildIconHash(){

    const scaledNodeW = nodeWidth * this.multiple;
    const scaledNodeH = nodeHeight * this.multiple;

    const circleIconDim = 20;

    /*
      porfilePic
     */
    const marginFromNodeToPic = 2;
    const scaledImgWidth = picDim * this.multiple;
    const scaledImgHeight = picDim * this.multiple;
    const scaleDistanceFromNodeXToPic = marginFromNodeToPic * this.multiple;
    const borderPicColorIsChanged = () => this.props.legendKey === 'borderGreen' || this.props.legendKey === 'borderPurple' || this.props.legendKey === 'borderBlue';

    /*
      addnodetab
     */
    const scaledWidthTab = scaledNodeW /2.6;
    const scaledHeightTab = scaledNodeH /5;
    const scaledAddTabLeft = this.nodeX + (scaledNodeW/2) - (scaledWidthTab/2) + 4;
    const scaledAddTabTop = this.nodeY + scaledNodeH - 1;


    const colorHash = {
      borderGreen: puplicProfileColor,
      borderBlue: claimedColor,
      borderPurple: masterProfileColor,
    }

    this.iconHash = {
      lineGrayUp:{
        x1: this.nodeX + (scaledNodeW/2),
        y1: this.nodeY,
        x2: this.nodeX + (scaledNodeW/2),
        y2: this.nodeY - 30,
        strokeWidth: 2,
        stroke: exStockColors[0]
      },
      lineGraySide:{
        x1: this.nodeX + scaledNodeW,
        y1: this.nodeY + scaledNodeH / 2,
        x2: this.nodeX + scaledNodeW + 30,
        y2: this.nodeY + scaledNodeH / 2,
        strokeWidth: 2,
        stroke: exStockColors[0]
      },
      lineBlackUp:{
        x1: this.nodeX + (scaledNodeW/2),
        y1: this.nodeY,
        x2: this.nodeX + (scaledNodeW/2),
        y2: this.nodeY - 30,
        strokeWidth: 2,
        stroke: 'black'
      },
      lineBlackSide:{
        x1: this.nodeX + scaledNodeW,
        y1: this.nodeY + scaledNodeH / 2,
        x2: this.nodeX + scaledNodeW + 30,
        y2: this.nodeY + scaledNodeH / 2,
        strokeWidth: 2,
        stroke: 'black'
      },
      lineDashed:{
        x1: this.nodeX + scaledNodeW,
        y1: this.nodeY + scaledNodeH / 2,
        x2: this.nodeX + scaledNodeW + 30,
        y2: this.nodeY + scaledNodeH / 2,
        strokeWidth: 2,
        dash: [3, 2.5],
      },
      lineColor1:{
        x1: this.nodeX + scaledNodeW,
        y1: this.nodeY + (scaledNodeH / 2) - 20,
        x2: this.nodeX + scaledNodeW + 30,
        y2: this.nodeY + (scaledNodeH / 2) - 20,
        strokeWidth: 2,
        stroke: exStockColors[0]
      },
      lineColor2:{
        x1: this.nodeX + scaledNodeW,
        y1: this.nodeY + (scaledNodeH / 2),
        x2: this.nodeX + scaledNodeW + 30,
        y2: this.nodeY + (scaledNodeH / 2),
        strokeWidth: 2,
        stroke: 'green'
      },
      lineColor3:{
        x1: this.nodeX + scaledNodeW,
        y1: this.nodeY + (scaledNodeH / 2) + 20,
        x2: this.nodeX + scaledNodeW + 30,
        y2: this.nodeY + (scaledNodeH / 2) + 20,
        strokeWidth: 2,
        stroke: exStockColors[1]
      },
      addTab:{
        src: assets.addnodetabImage,
        left: scaledAddTabLeft,
        top: scaledAddTabTop,
        width: scaledWidthTab - 1.2,
        height: scaledHeightTab - 1.2,
        strokeWidth: 0,
        stroke: exStockColors[2]
      },
      lockTab:{
        src: assets.lockTabImg,
        left: scaledAddTabLeft,
        top: scaledAddTabTop,
        width: scaledWidthTab,
        height: scaledHeightTab,
        strokeWidth: 0,
        stroke: 'white',
      },
      reloadTab:{
        src: assets.moretabImage,
        left: scaledAddTabLeft,
        top: scaledAddTabTop,
        width: scaledWidthTab,
        height: scaledHeightTab,
        strokeWidth: 0,
        stroke: 'white',
      },
      porfilePic:{
        src: this.props.placeholderImage_m,
        left: this.nodeX + scaleDistanceFromNodeXToPic,
        top: this.nodeY + scaleDistanceFromNodeXToPic,
        width: scaledImgWidth,
        height: scaledImgHeight,
        strokeWidth: borderPicColorIsChanged() ? 3: 1,
        stroke: `${ borderPicColorIsChanged() ? colorHash[this.props.legendKey]: 'gray'}`,
      },
      edit:{
        src: assets.editNodeImg,
        left: this.nodeX + scaledNodeW - 35 - 15,
        top: this.nodeY + scaledNodeH - 16,
        width: 12,
        height: 10,
        strokeWidth: 0,
        stroke: 'white',
        opacity: this.props.legendKey === 'edit' ? 1: editTreeActionOpacity
      },
      tree:{
        src: assets.treeImg,
        left: this.nodeX + scaledNodeW - 15 - 15,
        top: this.nodeY + scaledNodeH - 16,
        width: 18,
        height: 10,
        strokeWidth: 0,
        stroke: 'white',
        opacity: this.props.legendKey === 'tree' ? 1: editTreeActionOpacity
      },
      deadBanner:{
        src: assets.deadBannerImage,
        left: this.nodeX + 5,
        top: this.nodeY + 5,
        width: picDim,
        height: picDim,
        strokeWidth: 0,
        stroke: 'white',
      },
      presumedDeceased:{
        src: assets.presummedDeadBannerImage,
        left: this.nodeX + 5,
        top: this.nodeY + 5,
        width: picDim,
        height: picDim,
        strokeWidth: 0,
        stroke: 'white',
      },
      conflict:{
        src: assets.waringImage,
        left: this.nodeX - (circleIconDim/2) - 2,
        top: this.nodeY + scaledNodeH - (circleIconDim/2) - 5,
        width: picDim,
        height: picDim - 4,
        strokeWidth: 0,
        stroke: 'white',
      },
      gedcom:{
        src: assets.gedcomImg,
        left: this.nodeX - 8,
        top: this.nodeY + scaledNodeH - 9,
        width: picDim - 8,
        height: picDim - 8,
        strokeWidth: 0,
        stroke: 'white',
      },
      dna:{
        src: assets.dnaImg,
        left: this.nodeX + 30 + 6,
        top: this.nodeY + (picDim * this.multiple) - 5,
        width: picDim,
        height: picDim - 7,
        strokeWidth: 0,
        stroke: 'white',
      },
      dnaBlackBg:{
        left: this.nodeX + 32 + 6,
        top: this.nodeY + scaledNodeH - 12,
        width: circleIconDim,
        height: circleIconDim - 9,
        cornerRadius: 0,
        fill: "#000000",
      },
      matches_magnify_svg:{
        src: assets.magnifyImage,
        left: this.nodeX - circleIconDim / 2,
        top: this.nodeY - circleIconDim / 2,
        width: picDim,
        height: picDim,
        strokeWidth: 0,
        stroke: 'white',
      },
      smartMatchSVG:{
        src: assets.smartImg,
        left: 0,
        top: 0,
        width: 10,
        height: 10,
        strokeWidth: 0,
        stroke: 'black',
      },
      recordMatchSVG:{
        src: assets.recordImg,
        left: 0,
        top: 0,
        width: 10,
        height: 10,
        strokeWidth: 0,
        stroke: 'white',
      },
      geniMatchSVG:{
        src: assets.geniImg,
        left: 0,
        top: 0,
        width: 10,
        height: 10,
        strokeWidth: 0,
        stroke: 'white',
      },
      matchRect:{
        left: this.nodeX - (circleIconDim/2),
        top: this.nodeY + scaledNodeH - (circleIconDim/2),
        width: circleIconDim * 2,
        height: circleIconDim,
        cornerRadius: 0,
        fill: matchesColors.smart,
        text: '99',
        fontSize: 10,
        textLeft: 0,
        textTop: 0,
      },
      prune:{
        src: assets.baretreeImg,
        left: this.nodeX + scaledNodeW - 16,
        top: this.nodeY - 16,
        width: picDim + 7,
        height: picDim + 7,
        strokeWidth: 0,
        stroke: 'white',
        text: '16',
        fontSize: 10,
        textLeft: this.nodeX + scaledNodeW - 5,
        textTop: this.nodeY - 8,
      },
      matches_magnify_circle:{
        left: this.nodeX - 1,
        top: this.nodeY - 15,
        width: circleIconDim - 4,
        height: circleIconDim - 4,
        cornerRadius: circleIconDim,
        fill: "#2B66B5",
        text: '2',
        fontSize: 11,
        textLeft: this.nodeX + 3.7,
        textTop: this.nodeY - 11.5,
      },
      otherFamilyRect:{
        left: this.nodeX + 100,
        top: this.nodeY - 15,
        width: circleIconDim - 4,
        height: circleIconDim - 4,
        cornerRadius: 0,
        // fill: "#5AA92E",
        fill: "#008000",
        text: '2',
        fontSize: 9,
        textLeft: this.nodeX  + 100 + 5.3,
        textTop: this.nodeY - 11.4,
      },
      cycle:{
        // left: this.nodeX + scaledNodeW - (circleIconDim/2),
        // top: this.nodeY + scaledNodeH - (circleIconDim/2),
        left: this.nodeX - (circleIconDim/2),
        top: this.nodeY + scaledNodeH - (circleIconDim/2),
        width: circleIconDim,
        height: circleIconDim,
        cornerRadius: circleIconDim,
        fill: "#5AA92E",
        text: 'x3',
        fontSize: 10,
        // textLeft: this.nodeX + scaledNodeW - (circleIconDim/3.5),
        // textTop: this.nodeY + scaledNodeH - (circleIconDim/3.5) + 0,
        textLeft: this.nodeX - 6,
        textTop: this.nodeY + scaledNodeH - 5.5,
      },
      merge:{
        left: this.nodeX - (circleIconDim/2),
        top: this.nodeY + scaledNodeH - (circleIconDim/2),
        width: circleIconDim,
        height: circleIconDim,
        cornerRadius: 10,
        fill: "#2B66B5",
        text: '+',
        fontSize: 15,
        textLeft: this.nodeX - 4,
        textTop: this.nodeY + scaledNodeH - 8,
      },
      inconsistency:{
        left: this.nodeX - (circleIconDim/2),
        top: this.nodeY + scaledNodeH - (circleIconDim/2),
        width: circleIconDim,
        height: circleIconDim,
        cornerRadius: 10,
        fill: '#E96F20',
        text: '!',
        fontSize: 13,
        textLeft: this.nodeX - 2,
        textTop: this.nodeY + scaledNodeH - 6,
      },
    }

  }

  buildActionMenu() {

    let menuItemActionIdx = 0
    this.menuItemActions = [];

    for( let key in this.label.title){

      const title = this.label.title[`${key}`];
      const div = this.label.div[`${key}`];

      this.menuItemActions[menuItemActionIdx] = {};

      this.menuItemActions[menuItemActionIdx].title = title
      this.menuItemActions[menuItemActionIdx].div = div
      this.menuItemActions[menuItemActionIdx].key = key
      menuItemActionIdx++;

    }

  }

  buildDescriptionOnActionMenu() {

    let menuItemActionIdx = 0

    for( let key in this.label.title){

      this.menuItemActions[menuItemActionIdx].description = this.props.legendDescriptions[key]
      menuItemActionIdx++;

    }

  }

  buildLegendHash(){

    this.label = {
      panel:{},
      title:{},
      div:{},
    };

    this.label.panel.legendTitle = 'Family Tree Legend';
    this.label.panel.productTourLink = 'View Family Tree Tour';
    // this.label.panel.productTourLink = 'Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed  Lorem ipsum dolor sit';
    this.label.panel.instruction = 'Click on an icon in the left column to see its placement in the tree.';
    this.label.panel.cancel = 'Cancel';

    this.label.title.prune = 'Pruned Branch';
    this.label.div.prune = <div
                        className="legendIconsClick"
                        style={{
                          width: '25px',
                          height: '25px',
                          overflow: 'hidden',
                          position: 'relative',
                          backgroundImage: `url(${assets.baretreeImg.src})`,
                          backgroundSize: '25px',
                          backgroundPosition: '0px -1px',
                          backgroundRepeat: 'no-repeat',
                          margin: 'auto'
                        }}></div>;

    this.label.title.dna = 'DNA';
    this.label.div.dna = <div
                        className="legendIconsClick"
                        style={{
                          width: '26px',
                          height: '15px',
                          position: 'relative',
                          backgroundImage: `url(${assets.dnaImg.src})`,
                          backgroundSize: 'contain',
                          'background-color': 'black',
                          'background-size': '16px',
                          'background-position': '4px 16px',
                          margin: 'auto'
                        }}
                      ></div>;

    this.label.title.gedcom = 'GEDCOM Import';
    this.label.div.gedcom = <div
                        className="legendIconsClick"
                        style={{
                          width: '20px',
                          height: '20px',
                          position: 'relative',
                          backgroundImage: `url(${assets.gedcomImg.src})`,
                          backgroundSize: 'cover',
                          margin: 'auto'
                        }}></div>;

    this.label.title.conflict = 'Tree Conflict';
    this.label.div.conflict = <div
                      className="legendIconsClick"
                      style={{
                        width: '24px',
                        height: '20px',
                        position: 'relative',
                        backgroundImage: `url(${assets.waringImage.src})`,
                        backgroundSize: 'cover',
                        margin: 'auto'
                      }}
                    ></div>;

    this.label.title.edit = 'Edit';
    this.label.div.edit = <div
                        className="legendIconsClick"
                        style={{
                          width: '12px',
                          height: '14px',
                          position: 'relative',
                          backgroundImage: `url(${assets.editNodeImg.src})`,
                          backgroundSize: 'contain',
                          backgroundRepeat: 'no-repeat',
                          opacity: editTreeActionOpacity,
                          margin: 'auto'
                        }}></div>;

    this.label.title.tree = 'Refocus Tree';
    this.label.div.tree = <div
                        className="legendIconsClick"
                        style={{
                          width: '20px',
                          height: '14px',
                          position: 'relative',
                          backgroundImage: `url(${assets.treeImg.src})`,
                          backgroundSize: 'contain',
                          backgroundRepeat: 'no-repeat',
                          opacity: editTreeActionOpacity,
                          margin: 'auto'
                        }}></div>;

    this.label.title.add = 'Add Family Members';
    this.label.div.add = <div
                        className="legendIconsClick"
                        style={{
                          width: '76px',
                          height: '17px',
                          position: 'relative',
                          backgroundImage: `url(${assets.addnodetabImage.src})`,
                          backgroundSize: 'cover',
                          margin: 'auto',
                          backgroundRepeat: 'no-repeat',
                        }}></div>;

    this.label.title.reload = 'Reload';
    this.label.div.reload = <div
                        className="legendIconsClick"
                        style={{
                          width: '76px',
                          height: '17px',
                          position: 'relative',
                          backgroundImage: `url(${assets.moretabImage.src})`,
                          backgroundSize: 'cover',
                          margin: 'auto',
                          backgroundRepeat: 'no-repeat',
                        }}></div>;

    this.label.title.locked = 'Locked Profile';
    this.label.div.locked = <div
                        className="legendIconsClick"
                        style={{
                          width: '76px',
                          height: '17px',
                          position: 'relative',
                          backgroundImage: `url(${assets.lockTabImg.src})`,
                          backgroundSize: 'cover',
                          margin: 'auto',
                          backgroundRepeat: 'no-repeat',
                        }}></div>;

    this.label.title.match = 'Pending Matches';
    this.label.div.match = <div
                        className="legendIconsClick"
                        style={{
                          width: '20px',
                          height: '20px',
                          position: 'relative',
                          backgroundImage: `url(${assets.magnifyImage.src})`,
                          backgroundSize: 'cover',
                          margin: 'auto',
                          backgroundRepeat: 'no-repeat',
                        }}></div>;

    this.label.title.dead = 'Deceased';
    this.label.div.dead = <div
                        className="legendIconsClick"
                        style={{
                          width: '20px',
                          height: '20px',
                          position: 'relative',
                          backgroundImage: `url(${assets.deadBannerImage.src})`,
                          backgroundSize: 'cover',
                          margin: 'auto',
                          backgroundRepeat: 'no-repeat',
                        }}></div>;

    this.label.title.presumedDeceased = 'Presumed Deceased';
    this.label.div.presumedDeceased = <div
                        className="legendIconsClick"
                        style={{
                          width: '20px',
                          height: '20px',
                          position: 'relative',
                          backgroundImage: `url(${assets.presummedDeadBannerImage.src})`,
                          backgroundSize: 'cover',
                          margin: 'auto',
                          backgroundRepeat: 'no-repeat',
                        }}></div>;


    this.label.title.cycle = 'Cycle';
    this.label.div.cycle = <div
                        className="legendIconsClick"
                        style={{
                          width: '100%',
                          height: '100%',
                          margin: 'auto',
                        }}
                      >
                        <div class="circle divIcon">
                          <span>x3</span>
                        </div>
                      </div>;

    this.label.title.inconsistency = 'Inconsistency';
    this.label.div.inconsistency = <div
                        style={{
                          width: '100%',
                          height: '100%',
                          margin: 'auto',
                        }}
                      >
                        <div class="circle divIcon legendIconsClick" style={{
                          'background-color': '#E96F20',
                          'font-size': '11px',
                        }}>
                          <span>!</span>
                        </div>
                      </div>;

    this.label.title.merge = 'Requested Merge';
    this.label.div.merge = <div
                        style={{
                          width: '100%',
                          height: '100%',
                          margin: 'auto',
                        }}
                      >
                        <div class="circle divIcon legendIconsClick" style={{
                          'background-color': '#2B66B5',
                          'font-size': '13px'
                        }}>
                          <span style={{
                          'margin-bottom': '3px',
                        }}>+</span>
                        </div>
                      </div>;

    this.label.title.otherFamily = 'Multiple Sets of Parents';
    this.label.div.otherFamily = <div
                        style={{
                          width: '100%',
                          height: '100%',
                          margin: 'auto',
                        }}
                      >
                        <div class="squareBox divIcon legendIconsClick" style={{
                          'font-size': '11px',
                          'background-color': '#008000',
                        }}>
                          <span>2</span>
                        </div>
                      </div>;

    this.label.title.borderBlue = 'Blue Photo Border';
    this.label.div.borderBlue = <div
                        style={{
                          width: '100%',
                          height: '100%',
                          margin: 'auto',
                        }}
                      >
                        <div class="squareBox divIcon legendIconsClick" style={{
                          'font-size': '11px',
                          'border': `2px solid ${claimedColor}`,
                          width: '10px',
                          height: '10px',
                        }}>
                        </div>
                      </div>;

    this.label.title.borderPurple = 'Purple Photo Border';
    this.label.div.borderPurple = <div
                        style={{
                          width: '100%',
                          height: '100%',
                          margin: 'auto',
                        }}
                      >
                        <div class="squareBox divIcon legendIconsClick" style={{
                          'font-size': '11px',
                          'border': `2px solid ${masterProfileColor}`,
                          width: '10px',
                          height: '10px',
                        }}>
                        </div>
                      </div>;

    this.label.title.borderGreen = 'Green Photo Border';
    this.label.div.borderGreen = <div
                        style={{
                          width: '100%',
                          height: '100%',
                          margin: 'auto',
                        }}
                      >
                        <div class="squareBox divIcon legendIconsClick" style={{
                          'font-size': '11px',
                          'border': `2px solid ${puplicProfileColor}`,
                          width: '10px',
                          height: '10px',
                        }}>
                        </div>
                      </div>;

    this.label.title.lineGray = 'Related';
    this.label.div.lineGray = <div
                        style={{
                          width: '100%',
                          height: '100%',
                          margin: 'auto',
                        }}
                      >
                        <div class="squareBox divIcon legendIconsClick" style={{
                          'border':  '0px',
                          width: '30px',
                          height: '10px',
                        }}>
                          <div style={{
                            'margin-top':  '13px',
                            'border-top':  '2px solid gray',
                            'border-right':  '0px',
                            'border-left':  '0px',
                            'border-bottom':  '0px',
                            width: '100%',
                            height: '5px',
                          }}/>
                        </div>
                      </div>;

    this.label.title.lineBlack = 'Ancestors/Descendants';
    this.label.div.lineBlack = <div
                        style={{
                          width: '100%',
                          height: '100%',
                          margin: 'auto',
                        }}
                      >
                        <div class="squareBox divIcon legendIconsClick" style={{
                          'border':  '0px',
                          width: '30px',
                          height: '10px',
                        }}>
                          <div style={{
                            'margin-top':  '13px',
                            'border-top':  '2px solid black',
                            'border-right':  '0px',
                            'border-left':  '0px',
                            'border-bottom':  '0px',
                            width: '100%',
                            height: '5px',
                          }}/>
                        </div>
                      </div>;

    this.label.title.lineDashed = 'Divorce/Ex-partner';
    this.label.div.lineDashed = <div
                        style={{
                          width: '100%',
                          height: '100%',
                          margin: 'auto',
                        }}
                      >
                        <div class="squareBox divIcon legendIconsClick" style={{
                          'border':  '0px',
                          width: '30px',
                          height: '10px',
                        }}>
                          <div style={{
                            'margin-top':  '13px',
                            'border-top':  '2px dashed black',
                            'border-right':  '0px',
                            'border-left':  '0px',
                            'border-bottom':  '0px',
                            width: '100%',
                            height: '5px',
                          }}/>
                        </div>
                      </div>;

    this.label.title.lineColors = 'Other Marriages';
    this.label.div.lineColors = <div
                        style={{
                          width: '100%',
                          height: '100%',
                          margin: 'auto',
                        }}
                      >
                        <div class="squareBox divIcon legendIconsClick" style={{
                          'border':  '0px',
                          width: '30px',
                          height: '10px',
                        }}>
                          <div style={{
                            'margin-top':  '13px',
                            'border-top':  `2px solid ${exStockColors[5]}`,
                            'border-right':  '0px',
                            'border-left':  '0px',
                            'border-bottom':  '0px',
                            width: '100%',
                            height: '5px',
                          }}/>
                        </div>
                      </div>;

    this.translateLegendTitle();


  }

  translateLegendTitle(){

    if( typeof(window.trl) !== 'undefined' ){
      this.label.panel.legendTitle = window.trl(this.label.panel.legendTitle);
      this.label.panel.productTourLink = window.trl(this.label.panel.productTourLink);
      this.label.panel.instruction = window.trl(this.label.panel.instruction);
      this.label.panel.cancel = window.trl(this.label.panel.cancel);

      this.label.title.lineGray = window.trl(this.label.title.lineGray);
      this.label.title.lineBlack = window.trl(this.label.title.lineBlack);
      this.label.title.lineDashed = window.trl(this.label.title.lineDashed);
      this.label.title.lineColors = window.trl(this.label.title.lineColors);
      this.label.title.gedcom = window.trl(this.label.title.gedcom);
      this.label.title.add = window.trl(this.label.title.add);
      this.label.title.conflict = window.trl(this.label.title.conflict);
      this.label.title.merge = window.trl(this.label.title.merge);
      this.label.title.otherFamily = window.trl(this.label.title.otherFamily);
      this.label.title.match = window.trl(this.label.title.match);
      this.label.title.cycle = window.trl(this.label.title.cycle);
      this.label.title.dead = window.trl(this.label.title.dead);
      this.label.title.tree = window.trl(this.label.title.tree);
      this.label.title.prune = window.trl(this.label.title.prune);
      this.label.title.presumedDeceased = window.trl(this.label.title.presumedDeceased);
      this.label.title.reload = window.trl(this.label.title.reload);
      this.label.title.inconsistency = window.trl(this.label.title.inconsistency);
      this.label.title.borderBlue = window.trl(this.label.title.borderBlue);
      this.label.title.borderPurple = window.trl(this.label.title.borderPurple);
      this.label.title.borderGreen = window.trl(this.label.title.borderGreen);
      this.label.title.locked = window.trl(this.label.title.locked);
      this.label.title.edit = window.trl(this.label.title.edit);
      // this.label.title.multipleParentsLabel = window.trl(this.label.title.multipleParentsLabel);
      this.label.title.dna = window.trl(this.label.title.dna);
    }
  }


  detectSwipeBack(){

    let touchSwipeEventListener = undefined;
    let that = undefined;

    if( this.class === 'LegendList') {

      touchSwipeEventListener = document.querySelectorAll('#legendList .page__content');
      that = this;

      touchSwipeEventListener.forEach.call(touchSwipeEventListener, function(div) {

          div?.removeEventListener('touchstart', ()=>{});
          div?.addEventListener('touchstart', (event) => {

          // event.preventDefault();

          const touches = (event.touches.length > 0) ? event.touches : event.changedTouches;
          that.startMiliSec = Date.now();
          that.startTouchX = touches[0].clientX;
          that.startTouchY = touches[0].clientY;

        }, true);

      });

      touchSwipeEventListener.forEach.call(touchSwipeEventListener, function(div) {

          div?.removeEventListener('touchend', ()=>{});
          div?.addEventListener('touchend', (event) => {

            const touches = (event.touches.length > 0) ? event.touches : event.changedTouches;
            const endTouchX = touches[0].clientX;
            const endTouchY = touches[0].clientY;
            const changeInDistX = that.startTouchX - endTouchX;
            const changeInDistY = that.startTouchY - endTouchY;

            if( changeInDistX < 0 && Math.abs(changeInDistX) > Math.abs(changeInDistY)) that.backToTree()

          });

      });
    }

    if( this.class === 'LegendDescription') {

        touchSwipeEventListener = document.querySelectorAll('#legendDescription .page__content');
        that = this;

        touchSwipeEventListener.forEach.call(touchSwipeEventListener, function(div) {

            div?.removeEventListener('touchstart', ()=>{});
            div?.addEventListener('touchstart', (event) => {

            // event.preventDefault();

            const touches = (event.touches.length > 0) ? event.touches : event.changedTouches;
            that.startMiliSec = Date.now();
            that.startTouchX = touches[0].clientX;

          }, true);

        });

        touchSwipeEventListener.forEach.call(touchSwipeEventListener, function(div) {

            div?.removeEventListener('touchend', ()=>{});
            div?.addEventListener('touchend', (event) => {

              const touches = (event.touches.length > 0) ? event.touches : event.changedTouches;
              const endTouchX = touches[0].clientX;
              const changeInDistX = that.startTouchX - endTouchX;

              console.log(`changeInDistX: `, changeInDistX);

              console.log(`that.class: `, that.class);

              if( changeInDistX < 0 ) that.backToLegendList()

            });

        });


        this.nodeProfileLegendStage.current.container()?.removeEventListener('touchstart', ()=>{});
        this.nodeProfileLegendStage.current.container()?.addEventListener('touchstart', (event) => {

          // event.preventDefault();

          const touches = (event.touches.length > 0) ? event.touches : event.changedTouches;
          this.startMiliSec = Date.now();
          this.startTouchX = touches[0].clientX;
          this.startTouchY = touches[0].clientY;

        }, true);

        this.nodeProfileLegendStage.current.container()?.removeEventListener('touchend', ()=>{});
        this.nodeProfileLegendStage.current.container()?.addEventListener('touchend', (event) => {

              const touches = (event.touches.length > 0) ? event.touches : event.changedTouches;
              const endTouchX = touches[0].clientX;
              const changeInDistX = this.startTouchX - endTouchX;

              if( changeInDistX < 0 ) this.backToLegendList()

        });

    }

  }


}



